import { makeStyles } from '@material-ui/core';
import accurisLogoBlue from '../../assets/logos/accuris-logo-blue.png';
import accurisLogoWhite from '../../assets/logos/accuris-logo-white.png';

const useStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  img: {
    width: '100%',
    maxWidth: 132,
    height: 'auto',
    display: 'block',
  },
  light: {
    display: 'block',
    'body[data-theme-mode="dark"] &': {
      display: 'none',
    },
  },
  dark: {
    display: 'none',
    'body[data-theme-mode="dark"] &': {
      display: 'block',
    },
  },
});

const LogoMedium = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <img
        className={`${classes.img} ${classes.light}`}
        src={accurisLogoBlue}
        alt="Accuris"
      />
      <img
        className={`${classes.img} ${classes.dark}`}
        src={accurisLogoWhite}
        alt="Accuris"
      />
    </div>
  );
};

export default LogoMedium;
